import { EventEmitter, Injectable, Output } from "@angular/core";
import { ComponentActionTypes, TemplateRow, TriggeredComponentAction, VoyseComponent, VoyseGridComponent } from "@interfaces";

@Injectable({
    providedIn: "root",
})
export class ComponentActionsService {
    @Output() componentActionTriggered = new EventEmitter();
    @Output() componentActionReceived = new EventEmitter();

    constructor() {}

    public triggerComponentAction({
        action,
        componentIndex = null,
        rowIndex = null,
        gridIndex = null,
        rowData = null,
        componentData = null,
        gridComponentData = null,
    }: {
        action: ComponentActionTypes;
        componentIndex?: number;
        rowIndex?: number;
        gridIndex?: any;
        rowData?: TemplateRow,
        componentData?: VoyseComponent,
        gridComponentData?: VoyseGridComponent
    }) {
        this.componentActionTriggered.emit({ componentIndex, action, rowIndex, gridIndex, rowData, componentData, gridComponentData });
    }

    public receiveComponentAction(action: TriggeredComponentAction) {
        this.componentActionReceived.emit(action);
    }
}
